module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1"
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "prologue-1"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "width": "550px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "550px"
    },
    attrs: {
      "alt": "",
      "src": "media/image10.jpeg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right",
      "width": "500px",
      "font-size": "20pt",
      "font-family": "calibri",
      "padding-top": "100px"
    }
  }, [_c('em', [_vm._v("Chapter 1")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "500px",
      "font-size": "40pt",
      "font-family": "calibri",
      "text-align": "right"
    }
  }, [_vm._v("The North Sea")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "500px",
      "font-size": "10pt",
      "font-family": "calibri",
      "padding-top": "100px",
      "text-align": "right"
    }
  }, [_vm._v("View of the stallion approval in Groningen on 28th August, the city’s annual feast day")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "500px",
      "font-size": "10pt",
      "font-family": "calibri",
      "text-align": "right"
    }
  }, [_c('em', [_vm._v("Oil on canvas, Otto Erelman, 1920, City Hall, Groningen")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba203310","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0014.vue
// module id = 102
// module chunks = 0